import type { LearnerClient } from "@tutor/live";
import { createContext, useContext } from "react";

/** The live client of the signed-in learner, for components deep in the tree (widgets). */
export const LearnerClientContext = createContext<LearnerClient | null>(null);

export function useLearnerClient(): LearnerClient | null {
  return useContext(LearnerClientContext);
}
